import { render, staticRenderFns } from "./ButtonFinish.vue?vue&type=template&id=5e8b53bc&"
import script from "./ButtonFinish.vue?vue&type=script&lang=ts&"
export * from "./ButtonFinish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports